export * from './TermsAndCondition';
export * from './PrivacyPolicy';
